module.exports = __webpack_public_path__ + "static/media/amenity-ac.9be327dd.svg";